'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal(props) {
    _classCallCheck(this, Modal);

    var _this = _possibleConstructorReturn(this, (Modal.__proto__ || Object.getPrototypeOf(Modal)).call(this, props));

    _this.componentDidUpdate = function (prevProps) {
      if (_this.props.visible !== prevProps.visible) {
        _this.setState({ transitioning: true }, function () {
          window.requestAnimationFrame(function () {
            _this.setState({ visible: _this.props.visible }, function () {
              window.setTimeout(function () {
                _this.setState({ transitioning: false });
              }, 150);
            });
          });
        });
      }
    };

    _this.renderBackdrop = function () {
      if (_this.state.visible || _this.state.transitioning) {
        return _react2.default.createElement('div', {
          className: (0, _classnames2.default)('modal-backdrop', 'fade', { show: _this.state.visible }),
          onClick: _this.props.onClickBackdrop,
          role: 'presentation'
        });
      }

      return null;
    };

    _this.render = function () {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('modal', 'fade', { show: _this.state.visible }),
            style: { display: _this.state.visible || _this.state.transitioning ? 'block' : 'none' },
            role: 'dialog',
            'aria-hidden': !_this.state.visible
          },
          _react2.default.createElement(
            'div',
            { className: 'modal-dialog', role: 'document' },
            _react2.default.createElement(
              'div',
              { className: 'modal-content' },
              _this.props.children
            )
          )
        ),
        _this.renderBackdrop()
      );
    };

    _this.state = {
      visible: _this.props.visible
    };
    return _this;
  }

  // Shenanigans to allow the CSS fade to happen before we stop rendering the dialog or divs


  return Modal;
}(_react2.default.Component);

Modal.propTypes = {
  children: _propTypes2.default.node.isRequired,
  onClickBackdrop: _propTypes2.default.func,
  visible: _propTypes2.default.bool.isRequired
};
Modal.defaultProps = {
  onClickBackdrop: null
};
exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap4-modal/lib/Modal.js
// module id = 595
// module chunks = 0